import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Lock, ArrowRight, Crown } from "lucide-react";
import { usePlayerAuth } from "../context/PlayerAuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Starts a membership checkout for the signed-in profile (falls back to the public subscribe flow).
export async function startMembershipCheckout(player, tier = "academy") {
  const token = localStorage.getItem("playerToken");
  if (player?.id && token) {
    const { data } = await axios.post(`${API}/household/checkout`, { profile_id: player.id, tier, origin_url: window.location.origin },
      { headers: { Authorization: `Bearer ${token}` } });
    window.location.href = data.checkout_url;
    return;
  }
  window.location.href = `/subscribe?tier=${tier}`;
}

// Shown to Blueprint players who've used their one free coach review: direct Technical Track enrollment.
export const AcademyWaitlistLock = ({ note }) => {
  const { player } = usePlayerAuth();
  const [busy, setBusy] = useState("");
  const go = async (tier) => {
    setBusy(tier);
    try { await startMembershipCheckout(player, tier); }
    catch (err) { toast.error(err?.response?.data?.detail || "Couldn't start checkout. Please try again."); setBusy(""); }
  };
  return (
    <div data-testid="academy-waitlist-lock" className="w-full rounded-lg border border-[#C41E24]/40 bg-[#C41E24]/10 px-4 py-4">
      <div className="flex items-start gap-3">
        <Lock size={20} className="text-[#C41E24] shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="text-sm text-white/90 font-semibold">Unlock unlimited video reviews with the Technical Track</div>
          <div className="text-xs font-normal text-white/55 mt-1">{note || "You've used your free coach review. Enroll for unlimited uploads with personal voice feedback from Coach Barker."}</div>
          <div className="flex flex-col sm:flex-row gap-2 mt-3">
            <button data-testid="enroll-technical-track-btn" onClick={() => go("academy")} disabled={!!busy}
              className="flex-1 flex items-center justify-center gap-2 bg-[#C41E24] hover:bg-[#A0161D] text-white font-subheadings font-bold uppercase tracking-wider text-sm px-5 py-3 rounded-md transition-colors disabled:opacity-60">
              {busy === "academy" ? "Redirecting…" : "Enroll in the Technical Track — $29/mo"} <ArrowRight size={15} />
            </button>
            <button data-testid="enroll-elite-btn" onClick={() => go("elite")} disabled={!!busy}
              className="flex items-center justify-center gap-2 border border-[#D4AF37]/60 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black font-subheadings font-bold uppercase tracking-wider text-sm px-5 py-3 rounded-md transition-colors disabled:opacity-60">
              <Crown size={14} /> {busy === "elite" ? "Redirecting…" : "Go Elite — $49/mo"}
            </button>
          </div>
          <p className="text-[10px] text-white/40 mt-2 uppercase tracking-wider">Cancel anytime · Billed monthly · Founding Member pricing locked for life</p>
        </div>
      </div>
    </div>
  );
};

export default AcademyWaitlistLock;
